import { Component, OnInit } from '@angular/core';
import { HttpService } from '../core/services/http.service';
import { EnterpriseLocationService } from '../core/services/enterprise-location.service';
import { EnterpriseService } from '../core/services/enterprise.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-select-enterprise-location',
  templateUrl: './select-enterprise-location.component.html',
  styleUrls: ['./select-enterprise-location.component.css']
})
export class SelectEnterpriseLocationComponent implements OnInit {
  selectedEnterprise: any = null;
  enterprises: any[] = [];
  locations: any[] = [];
  constructor(
    private httpService: HttpService,
    private enterpriseService: EnterpriseService,
    private locationService: EnterpriseLocationService,
    private router: Router
  ) {}

  ngOnInit() {
    this.fetchEnterprises();
  }

  async fetchEnterprises() {
    try {
      const enterprisesResponse = await this.httpService
        .get<any[]>(`Enterprise`)
        .toPromise();
      this.enterprises = enterprisesResponse || [];
    } catch (err) {
      console.error(err);
      alert('Error fetching timezones');
    }
  }

  async fetchLocations(enterpriseId: number) {
    try {
      const locationsResponse = await this.httpService
        .get<any[]>(`Enterprise/${enterpriseId}/Location`)
        .toPromise();
      this.locations = locationsResponse || [];
    } catch (err) {
      console.error(err);
      alert('Error fetching timezones');
    }
  }

  handleEnterpriseClick(enterprise: any) {
    this.selectedEnterprise = enterprise;
    this.enterpriseService.setCurrentEnterpriseActiveItem(enterprise);
    this.fetchLocations(enterprise.id);
  }

  handleLocationClick(location: any) {
    console.log(location);

    this.locationService.setCurrentEnterpriseLocationActiveItem(location);
    this.router.navigate(['/overview']);
  }
}
